// extracted by mini-css-extract-plugin
export default {"form":"HallModal_form__6xgpZ"};